import React, { Component } from "react";
import moment from "moment";
import Moment from "react-moment";
import { FiCalendar } from "react-icons/fi";
import { calendarsService } from "services";
import { withTranslation } from "react-i18next";

class Dashboard_NextHolidays extends Component {
	constructor(props) {
		super(props);
		// console.log(props);

		this.state = {
			upcommig_holidays: [],
			isHoliday: false,
		};
	}

	componentDidMount() {
		this.getUpcommingHolidays();
	}

	async getUpcommingHolidays() {
		const response = await calendarsService.getUpcomingHolidays();
		const upcommig_holidays = response.filter((day) => day.holidays);

		if (response.ok) {
			this.setState({
				upcommig_holidays,
			});
		}
	}

	getDayRows = () =>
		this.state.upcommig_holidays.flatMap((holiday) =>
			this.getDayHolidays(holiday.holidays, holiday.day)
		);

	getHolidayDescription = (holiday, date) => {
		if (holiday.day.description) return holiday.day.description;

		const calendar = holiday.calendar;
		const specialDay = calendar?.special_days?.find((day) => moment(day.day).isSame(date, "day"));
		const weekday = calendar?.weekdays?.find((day) => day.weekday === moment(date).isoWeekday());
		const dayType = (specialDay || weekday)?.day_type;

		return dayType?.description || "";
	};

	getDayHolidays = (holidays, date) =>
		holidays.map((holiday, index) => {
			return (
				<li key={`${holiday.calendar.id}-${date}-${index}`} className="holiday">
					<div className="item-main">
						<span className="item-name">{this.getHolidayDescription(holiday, date)}</span>
						<Moment format="D MMMM YYYY" className="item-info">
							{date}
						</Moment>
					</div>
				</li>
			);
		});

	render() {
		const { upcommig_holidays } = this.state;

		const { t } = this.props;

		if (upcommig_holidays.length > 0) {
			return <ul className="list-days">{this.getDayRows()}</ul>;
		} else {
			return (
				<div className="empty">
					<FiCalendar />
					<p>{t("widgets.nextHolidays.noHolidays")}</p>
				</div>
			);
		}
	}
}

export default withTranslation()(Dashboard_NextHolidays);
